<template>
    <va-create-layout>
        <suppliers-form :title="title" :item="item"></suppliers-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
